import { createAsyncThunk } from '@reduxjs/toolkit';
import ax from 'services/apiService';
import { setDownloadProgress } from '../downloadIndicator';

// menu/account_list
export const getAccountList = createAsyncThunk('account-list-grid', async (payload: any, { rejectWithValue }) => {
    try {
        // const response = await ax.post(`api/api/menu/account_list`, payload);

        // console.log('Headers in Axios:', response.headers); // <-- should include x-real-data

        // const successMessage = response.data.successMessage;
        // const encodedData = response.headers['x-real-data'];

        // let realData = null;
        // if (encodedData) {
        //     const decodedStr = atob(encodedData);
        //     realData = JSON.parse(decodedStr);
        // }

        // return realData;
        const { data } = await ax.post(`api/api/Account/account_list`, payload);
        // console.log(
        //     "data", data
        // )
        // if (data.file) {
        //     const fileResponse = await ax.get(data.file);
        //     console.log("filePath", fileResponse);
        //     return fileResponse.data; // Actual API data from file

        // }

        // return [];
        // Success message from body (visible in Network tab
        //      if (data.token) {
        //     const realDataRes = await ax.get(`/api/real-data/${data.token}`);
        //     return realDataRes.data;
        //   }

        //   return [];

        // return data;
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// menu/generate_account
export const addAccount = createAsyncThunk('add-account', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/Account/generate_account`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const removeAccount = createAsyncThunk('remove-account', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`api/api/menu/remove_account`, payload);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// menu/get_account/accountid/tenantid
export const getAccountDetail = createAsyncThunk('get-account-infor', async (id: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.get(`api/api/Account/get_account/${id}`);
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
// menu/public_account
export const validatePublicReq = createAsyncThunk(
  'validate-publicform-account',
  async (payload: any, { rejectWithValue }) => {
    try {
      const response = await ax.post(`api/public_account`, payload);

      const data = response.data;


      // 🔹 Separate useful data
      const publicAccount = data?.publicAccount;
      const accountDetails = data?.accountDetails;

      // 🔹 Optional validation
      if (!publicAccount || !accountDetails) {
        return rejectWithValue('Invalid API response structure');
      }

      // 🔹 Return structured data
      return {
        publicAccount,
        accountDetails,
      };

    } catch (error: any) {
      console.error(error, 'THUNK ERROR');

      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
// menu/sample_temp_download
export const getSampleFile = createAsyncThunk('get-sample-file', async (payload: any, { dispatch, rejectWithValue }) => {
    try {
        dispatch(setDownloadProgress(0));
        let uploadprogress = 0;
        const { data } = await ax.post(`api/api/menu/sample_temp_download`, payload, {
            onUploadProgress: (progressEvent: any) => {
                uploadprogress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                dispatch(setDownloadProgress(uploadprogress));
            },
        });
        return data;
    } catch (error: any) {
        // return custom error message from API if any
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
